const CLIENT_ID = '69fea69f-b113-4188-b8b6-d7d804c5da53';
import {azureClientId, azureTenantId} from "../../config.json";

export const msalConfigDefault = {
    auth: {
        clientId: azureClientId,
        authority: "https://login.microsoftonline.com/" + azureTenantId
        // redirectUri: window.location.origin
    },
    cache: {
        cacheLocation: "sessionStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    }
};

// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginRequestDefault = {
    scopes: ['openid', 'profile']
};

// Add scopes here for access token to be used at Microsoft Graph API endpoints.
export const tokenRequestDefault = {
    scopes: ['api://' + azureClientId + '/access_as_user']
};